import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll reset on route changes for routes that render outside the
 * main app layouts (auth, landing, etc.). Layouts also reset their own
 * scroll containers via useScrollResetOnRouteChange.
 *
 * When a hash is present, scroll to that anchor instead.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 20) {
          setTimeout(() => tryScroll(attempt + 1), 100);
        }
      };
      tryScroll();
      return;
    }

    const reset = () => {
      const container = document.getElementById("main-scroll-container");
      container?.scrollTo({ top: 0, left: 0, behavior: "auto" });
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    reset();
    const raf = requestAnimationFrame(reset);
    const t = window.setTimeout(reset, 220);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t);
    };
  }, [pathname, hash]);

  return null;
}
